import { NetworkPointResource } from 'app/_resources/network-point.resource';
import * as angular from 'angular';
import { TransmissionSystemOperatorResource } from 'app/_resources/transmission-system-operator.resource';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('CreateProposalStageOneCtrl', CreateProposalStageOneCtrl);

    function CreateProposalStageOneCtrl(
        $q,
        $scope,
        $location,
        createProposalService,
        networkPointSearchService,
        remitReportingService,
        NetworkPoint: NetworkPointResource,
        TransmissionSystemOperator: TransmissionSystemOperatorResource,
        TradeProposals
    ) {
        // in order to have access per $controller in CreateProposalCtrl
        $scope.setDataForNetworkPoint = fetchDataForNetworkPoint;
        $scope.fetchTsoConfig = fetchTsoConfig;
        $scope.fetchChannelConfig = fetchChannelConfig;

        var vm = this,
            nwpId;
        vm.submit = submit;
        vm.networkPointName = undefined;
        vm.parseSelection = parseSelection;
        vm.INPUT_ADDON = networkPointSearchService.INPUT_ADDON;

        init();

        function init() {
            vm.ui = {};
            vm.data = createProposalService.getStageOne();
            if (vm.data.selectedNetworkPoint) {
                nwpId = vm.data.selectedNetworkPoint.id;
                vm.networkPointName = vm.data.selectedNetworkPoint.name;
            }
        }

        // first check if a network point id is provided in the URL,
        // if so, we need to fetch this network point and set it as a variable here.
        const networkPointIdQuery = $location.search().networkPointId;
        if (networkPointIdQuery) {
            $location.search('networkPointId', undefined);
            // this should support new flows coming from react (e.g. nwp details page)
            NetworkPoint.get(
                {
                    id: networkPointIdQuery,
                    'include-links': true,
                    'include-selling-methods': true
                },
                (res) => {
                    createProposalService.setNetworkPoint(res);
                    handleNetworkPointDeepLink();
                },
                (err) => {}
            );
        } else {
            // this should support old flows coming from angular (e.g. dashboard)
            handleNetworkPointDeepLink();
        }

        function handleNetworkPointDeepLink() {
            var networkPoint = createProposalService.getNetworkPoint();
            if (
                !angular.isUndefined(networkPoint) &&
                !angular.isUndefined(networkPoint.name)
            ) {
                finishStageWith(networkPoint.id);
                createProposalService.setNetworkPoint({});
            }
        }

        function submit(form: ng.IFormController) {
            if (!form.$valid) {
                $scope.wizard.goToTop();
                return false;
            }
            finishStageWith(nwpId);
        }

        function finishStageWith(networkPointId) {
            var getTsoConfigRequest = fetchTsoConfig(networkPointId);
            var getChannelConfigRequest = fetchChannelConfig();
            var setDataRequest = fetchDataForNetworkPoint(networkPointId);
            var promises = [
                getTsoConfigRequest.$promise,
                getChannelConfigRequest,
                setDataRequest
            ];
            $q.all(promises).then(
                function () {
                    vm.ui.generalError = false;
                    $scope.wizard.goToNextStage();
                    return true;
                },
                function () {
                    vm.ui.generalError = true;
                    return false;
                }
            );
        }

        function fetchDataForNetworkPoint(networkPointId) {
            return NetworkPoint.get(
                { id: networkPointId, detailLevel: 'PUBLIC' },
                function (res) {
                    if (
                        createProposalService.getStageOne()
                            .selectedNetworkPoint &&
                        networkPointId !=
                            createProposalService.getStageOne()
                                .selectedNetworkPoint.id
                    ) {
                        createProposalService.reset();
                    }
                    vm.data.selectedNetworkPoint = res;

                    if (!angular.isUndefined(res.tso0Id)) {
                        TransmissionSystemOperator.get(
                            { id: res.tso0Id, detailLevel: 'PUBLIC' },
                            function (res) {
                                vm.data.tso0 = res;
                            }
                        );
                    } else {
                        delete vm.data.tso0;
                    }
                    if (!angular.isUndefined(res.tso1Id)) {
                        TransmissionSystemOperator.get(
                            { id: res.tso1Id, detailLevel: 'PUBLIC' },
                            function (res) {
                                vm.data.tso1 = res;
                            }
                        );
                    } else {
                        delete vm.data.tso1;
                    }
                    createProposalService.setStageOne(vm.data);
                }
            ).$promise;
        }

        function fetchTsoConfig(networkPointId) {
            return TradeProposals.tsoConfig(
                {
                    networkPointId: networkPointId
                },
                function (res) {
                    vm.data.tsoConfig = res;
                    createProposalService.setStageOne(vm.data);
                }
            );
        }

        function parseSelection(selectedNetworkPoints, isFromQuickfilter) {
            nwpId = selectedNetworkPoints.id;
            vm.networkPointName = selectedNetworkPoints.name;
        }

        function fetchChannelConfig() {
            return remitReportingService
                .secondaryRemitReportingSettings()
                .then((res) => {
                    vm.data.remitReportingSettings = res || {
                        orgId: '',
                        active: false,
                        channels: []
                    };
                    createProposalService.setStageOne(vm.data);
                });
        }
    }
})();
